import React, { useEffect, useState } from 'react';
import './AboutContents.scss';

const AboutContents2 = ({ setProductPosition }) => {
  const [target, setTarget] = useState(null);

  const onIntersect = async ([entry], observer) => {
    if (entry.isIntersecting) {
      observer.unobserve(entry.target);
      setProductPosition(target.id);

      observer.observe(entry.target);
    } else {
    }
  };

  useEffect(() => {
    let observer;
    if (target) {
      observer = new IntersectionObserver(onIntersect, { threshold: 0.5 });
      observer.observe(target);
    }
    return () => observer && observer.disconnect();
  });

  return (
    <div id="AboutLast" className="aboutContents" ref={setTarget}>
      <div className="aboutContentsLeft">
        <div className="aboutContentsLeftTitle">
          열전소자의 자가발전으로, <br />
          난로의 온기를 바닥까지 따뜻하게{' '}
        </div>
        {/* <div className="aboutContentsLeftSlogan"> */}
        {/* 무동력팬 원리 or 기능 설명 페이지 */}
        {/* </div> */}
        <img
          className="productImage2"
          src="/images/DC-100_TUF.jpg"
          alt="AboutImage"
        />
        <div className="aboutContentsLeftInfo2">
          <p>외부 전원 공급 없이, </p>
          <p>난로 위에 올리는 것 만으로 동작합니다. </p>
          <p>난로의 뜨거운 공기를 아래쪽으로 대류시켜</p>
          <p>따뜻한 공기가 텐트 내부를 순환하여</p>
          <p>편안하고 따뜻한 겨울 캠핑을 즐길 수 있습니다.</p>
        </div>
      </div>
      {/* <div className="aboutContentsRight">Product Img</div> */}
    </div>
  );
};

export default AboutContents2;
